export default {
    path: '/receivingOrders',
    name: 'receivingOrders',
    component: () =>
        import(/* webpackChunkName: "receivingOrders" */ "@/pages/receivingOrders/views/index.vue"),
    meta: {
        title: '接单方处理简历'
    },
}